import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { UserMessageData } from "common";
import { LoanData } from "../../loan/domain/models/loan.model";
import { DashboardContentComponentData } from "./dashboard-content.model";
import { DashboardContentFacade } from "./dashboard-content.facade";

@Component({
    selector: "ifp-dashboard-content",
    templateUrl: "./dashboard-content.component.html",
    styleUrls: ["./dashboard-content.component.scss"],
    providers: [DashboardContentFacade],
    standalone: false
})
export class DashboardContentComponent implements OnInit {
  readonly data$: Observable<DashboardContentComponentData>;

  constructor(private readonly facade: DashboardContentFacade) {
    this.data$ = this.facade.getData$();
  }

  ngOnInit(): void {
    this.facade.init();
  }

  dismissMessage(data: DashboardContentComponentData, message: UserMessageData): void {
    this.facade.dismissMessage(data, message);
  }

  filterCFLoans(data: DashboardContentComponentData, input: LoanData): void {
    this.facade.filterCFLoans(data, input);
  }

  closeFilterCFLoans(data: DashboardContentComponentData): void {
    this.facade.closeFilterCFLoans(data);
  }

  filterLoans(data: DashboardContentComponentData, input: LoanData): void {
    this.facade.filterLoans(data, input);
  }

  closeFilterLoans(data: DashboardContentComponentData): void {
    this.facade.closeFilterLoans(data);
  }

  setShowCaseFinanceFilter(data: DashboardContentComponentData, value: boolean): void {
    this.facade.setShowCaseFinanceFilter(data, value);
  }

  setShowAccountsFilter(data: DashboardContentComponentData, value: boolean): void {
    this.facade.setShowAccountsFilter(data, value);
  }

  link(): void {
    this.facade.link();
  }

  fundAnotherCase(): void {
    this.facade.fundAnotherCase();
  }

  showAvailableFundsDialog(data: DashboardContentComponentData): void {
    this.facade.showAvailableFundsDialog(data);
  }

  openLoyaltyRewardDialog(): void {
    this.facade.openLoyaltyRewardDialog();
  }
}
